@use '@fpsm/cxy-scss' as cxy;

body:has(dialog[open]) {
  overflow: hidden;
}

.bettingInsightsSection {
  grid-area: section;
  color: var(--cxy-color-text-default-body);
  padding-inline: var(--cxy-spacing-xsm);
}
@media (min-width: 801px) {
  .bettingInsightsSection {
    padding-inline-start: 0;
  }
}

.bettingInsightsResults {
  @include cxy.stack(var(--cxy-spacing-xsm));
  padding-bottom: var(--cxy-spacing-xxxsm);
}

.bettingInsightsPagination {
  grid-area: pagination;
  padding: var(--cxy-spacing-lg) 0;
  display: flex;
  justify-content: center;
}

.isVisiblyHidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.loadingState {
  @include cxy.stack(var(--cxy-spacing-lg));
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .loadMore {
    background-color: var(--cxy-color-surface-secondary-default-subtle);
    color: var(--cxy-color-text-default-placeholder);
    font-weight: var(--cxy-fontWeight-normal);
  }

  .lastPage {
    margin-bottom: var(--betting-insights-results-margin-bottom, 60px);
  }
}

.disclaimer {
  font-size: var(--cxy-fontSize-s);
  margin: var(--cxy-spacing-xsm) 0;
}
